export default "__VITE_ASSET__ghbdWBOx__";